import {AppConfigService} from './app-config.service';
import {Subscription} from './app-models/models';
import {Headers} from '@angular/http';
import {HttpClientService} from './http-client.service';
import {Injectable} from '@angular/core';

@Injectable()
export class CreateSubscriptionService {

  private apiUrl = AppConfigService.settings.apiUrl + 'subscriptions/';

  constructor(private http: HttpClientService) {
  }

  getData(id: string): Promise<Subscription> {
    return this.http.get(this.apiUrl + 'getsites?custId=' + id)
      .toPromise()
      .then(response => response.json() as Subscription)
      .catch(this.handleError);
  }

  createSubscription(data: Subscription): Promise<Subscription> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl + 'create', JSON.stringify(data), headers)
      .toPromise()
      .then(response => response.json() as Subscription)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// ./src/app/create-subscription.service.ts